/**
 * Calendar Pagelet - Navigation functions for calendar pagelet.
 * Provides day, month, and today navigation for calendar widgets.
 */

// Declare external dependencies
declare class MyDate {
  setFromDate(date: Date): this;
  getAsString(monthFormat: number, yearFormat: number): string;
}

// Interface for form object
interface FormObject {
  name: string;
  getElement(name: string): FormElement;
}

// Interface for form element
interface FormElement {
  formObj: FormObject;
  get: () => string;
  set: (value: string) => void;
  getSibling: (name: string) => FormElement;
}

/**
 * Navigate to a specific day
 * @param y - Year
 * @param m - Month
 * @param d - Day
 * @param id - Form ID
 */
function goDay(y: number, m: number, d: number, id: string): void {
  const date = getFormObj(id).getElement("_date");
  date.set(m + "/" + d + "/" + y);
  submitForm(date.formObj.name);
}

/**
 * Navigate to today's date
 * @param id - Form ID
 */
function goToday(id: string): void {
  const date = getFormObj(id).getElement("_date");
  date.set(new MyDate().setFromDate(currentDateTime()).getAsString(2, 4));
  submitForm(date.formObj.name);
}

/**
 * Navigate to a specific month
 * @param y - Year
 * @param m - Month
 * @param id - Form ID
 */
function goMonth(y: number, m: number, id: string): void {
  const date = getFormObj(id).getElement("_date");
  const view = date.getSibling("_view");
  view.set("M");
  date.set(m + "/01/" + y);
  submitForm(date.formObj.name);
}

// Export for module usage
export { goDay, goToday, goMonth };

// Export types
export type { FormObject, FormElement };

// Expose on globalThis for backwards compatibility
(globalThis as any).goDay = goDay;
(globalThis as any).goToday = goToday;
(globalThis as any).goMonth = goMonth;

// Script resource notification
if (typeof _SR_ !== "undefined" && _SR_ !== null) {
  _SR_.notify("calpagelet.js");
}
